import * as React from "react";
import PaymentCancelFinishPage from "../pages/PaymentCancelFinish";

const PaymentCancelFinishContainer = () => {
    return <PaymentCancelFinishPage />;
};

export default PaymentCancelFinishContainer;
